<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index">
      {{ item }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'Breadcrumb',
  setup() {
    const route = useRoute()
    
    const breadcrumbs = computed(() => {
      return route.matched
        .filter(item => item.path !== '/' && item.meta?.title)
        .map(item => item.meta.title)
    })
    
    return {
      breadcrumbs
    }
  }
}
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  font-size: 14px;
}
</style>
